import React from "react";
import "./InputCheckbox.scss";

type InputCheckboxProps = {
    name?: string;
    id: string;
    label?: string;
    checked?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    spacing?: string;
    align?: "flex-start" | "center" | "flex-end" | "space-between";
    onlyCheckbox?: boolean;
};

const InputCheckbox: React.FC<InputCheckboxProps> = ({
    name,
    id,
    label,
    checked = false,
    onChange,
    spacing = "12px",
    align = "flex-start",
    onlyCheckbox = false,
}) => {
    const containerStyle =
        align === "space-between" ? { justifyContent: "space-between" } : {};

    return (
        <div
            className={`input-checkbox ${onlyCheckbox ? "only-checkbox" : ""}`}
            style={containerStyle}
        >
            <input
                name={name}
                type="checkbox"
                id={id}
                checked={checked}
                onChange={onChange}
                className="input-checkbox__input"
            />
            {!onlyCheckbox && label && (
                <label
                    htmlFor={id}
                    className="input-checkbox__label"
                    style={{
                        marginLeft: align !== "space-between" ? spacing : "0",
                    }}
                >
                    {label}
                </label>
            )}
        </div>
    );
};

export default InputCheckbox;
